import axios from 'axios';

const mothership = axios.create({
    baseURL: process.env.REACT_APP_MOTHERSHIP,
});

export default mothership;
